import actions from './actions'
import saga from '../../GeneralListFunctions/sagaFactory'

export default () => saga(actions, () => 'v1/user', state => state.mailUser)
